import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { FilterQuery } from "shared";

import { PAGE_SIZE } from "../view/SearchResult";
import { searchTopologyQuery } from "./searchTopology.query";

type Options = {
  enabled?: boolean;
};

export const useSearchTopology = (
  {
    filtersParams,
    id,
    limit,
    shouldReturnChildrenOfAssembly,
    dimensionWeight,
  }: {
    id: string | undefined;
    filtersParams: FilterQuery;
    limit?: number;
    shouldReturnChildrenOfAssembly?: boolean;
    dimensionWeight?: number;
  },
  options: Options = { enabled: true },
) => {
  const { data, ...rest } = useQuery({
    ...searchTopologyQuery(
      id,
      filtersParams,
      limit,
      shouldReturnChildrenOfAssembly,
      dimensionWeight,
    ),
    placeholderData: limit && limit > PAGE_SIZE ? keepPreviousData : undefined,
    enabled: options.enabled && !!id,
  });

  return { similarParts: data, ...rest };
};
